const Support = ({ className }: { className?: string }) => {
  return (
    <svg
      width="38"
      height="35"
      viewBox="0 0 38 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.7647 0C1.69412 0 0 1.65789 0 3.68421V25.7895L5.64706 20.2632H22.5882C24.6588 20.2632 26.3529 18.6053 26.3529 16.5789V3.68421C26.3529 1.65789 24.6588 0 22.5882 0H3.7647ZM30.1176 9.21053V16.5789C30.1176 20.6426 26.7407 23.9474 22.5882 23.9474H11.2941V25.7895C11.2941 27.8158 12.9882 29.4737 15.0588 29.4737H32L37.647 35V12.8947C37.647 10.8684 35.9529 9.21053 33.8823 9.21053H30.1176Z"
        fill="#FB2576"
      />
    </svg>
  );
};

export default Support;
